import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as actions from "redux/actions";
import ForragemService from "services/ForragemService";
import csvtojson from "csvtojson";
import { Typography, withStyles } from "@material-ui/core";
import { ButtonWithLabel, UploadButtonWithLabel } from "./ButtonWithLabel";
import ConfirmationModal from "features/shared/components/confirmationModal";
import { t, Trans } from "adapters/i18n";

class ForageOptions extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      csvTratado: null,
      idFazenda: null,
    };
  }

  setOpen = (status) => {
    this.setState({ open: status });
  };

  handleOpen = () => {
    this.setOpen(true);
  };

  handleParamentros = (idaFazenda = null, csv = null) => {
    this.setState({ idFazenda: idaFazenda, csvTratado: csv });
  };

  handleClose = () => {
    this.setOpen(false);
    this.handleParamentros();
  };

  // pega o csv trata e valida se tem o compra IdCicloForragemFazenda está fazio
  handleSalvaCicloForragemCsv = async (...parametros) => {
    const [csv, IdFazenda] = parametros;
    const csvTratado = await this.converteCsv(csv);
    let continua = true;
    this.handleParamentros(IdFazenda, csvTratado);
    csvTratado.forEach((linha) => {
      if (!linha.IdCicloForragemFazenda) {
        continua = false;
        this.handleOpen();
      }
    });
    if (continua) {
      this.salvarForragemCsv();
    }
  };
  // salva e esvazia o state da pagina
  salvarForragemCsv = async () => {
    try {
      await ForragemService.salvaCiclosForragemCsv(
        this.state.csvTratado,
        this.state.idFazenda
      );
      this.handleClose();
      this.props.notifySuccess({
        mensagem: t("success:forage-cycles.update-success"),
      });
    } catch (error) {
      this.handleClose();
      const mensagemErro = error.message
        ? error.message
        : t("errors:forage-registration.update-cycle-csv");
      this.props.notifyError({
        mensagem: mensagemErro,
      });
    }
  };

  converteCsv = async (csv) => {
    const csvConverterJson = csv.replace(/ï»¿/g, "");
    const objetoCsv = await csvtojson({ delimiter: "\t" }).fromString(
      csvConverterJson.replace(/;/g, "\t")
    );
    return objetoCsv;
  };

  onDrop = (files) => {
    const { fazendaSelecionada } = this.props;

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () =>
        this.handleSalvaCicloForragemCsv(reader.result, fazendaSelecionada);
      reader.onerror = () =>
        this.props.notifyError({
          mensagem: t("pasture:import-kml-error"),
          variant: "error",
        });
      reader.readAsBinaryString(file);
    });
  };

  validaInputArquivo = (accepted, rejected) => {
    if (accepted.length > 1) {
      this.props.notifyInfo({
        mensagem: t("errors:file.only-one-file-supported"),
      });
      return;
    }

    if (accepted.length) {
      this.onDrop(accepted);
      return;
    }

    if (rejected.length) {
      this.props.notifyInfo({
        mensagem: t("errors:file.only-csv-supported"),
      });
      return;
    }
  };

  showError = () => {
    this.props.notifyError({
      mensagem: t("errors:file.download-file-error"),
    });
  };

  listaForragensERealizaDownload = async () => {
    ForragemService.listaForragensERealizaDownloadCsv().catch(() => {
      this.showError();
    });
  };

  listaCiclosForragemERealizaDownload = () => {
    const { fazendaSelecionada } = this.props;
    ForragemService.listaCiclosForragensPorIdFazenda(fazendaSelecionada).catch(
      () => {
        this.showError();
      }
    );
  };

  formatModalText() {
    const { classes } = this.props;
    return (
      <Trans
        i18nKey="pasture:import-forage-csv-modal-description"
        components={{
          span: <Typography className={classes.modalText} />,
          bold: <b />,
        }}
      />
    );
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <>
        <div data-testid="containerCadastroForragem">
          <div className={classes.containerInfo}>
            <Typography variant="subtitle2" className={classes.subtitle}>
              <Trans i18nKey="pasture:select-desired-option" />
            </Typography>
          </div>
          <ButtonWithLabel
            labelText={t("pasture:export-all-forages-csv")}
            buttonText={t("pasture:export-csv")}
            onClick={this.listaForragensERealizaDownload}
          />
          <ButtonWithLabel
            labelText={t("pasture:export-forage-csv-for-period")}
            buttonText={t("pasture:export-csv")}
            onClick={this.listaCiclosForragemERealizaDownload}
          />
          <UploadButtonWithLabel
            labelText={t("pasture:import-csv-for-forage")}
            buttonText={t("pasture:import-csv")}
            allowedExtensions=".csv"
            uploadType="uploadCsv"
            onInputFileOpen={() => {}}
            onDrop={this.validaInputArquivo}
            disabled={this.props.disable}
          />
        </div>
        {open && (
          <ConfirmationModal
            title={t("pasture:observation")}
            text={this.formatModalText()}
            submitButtonTitle={t("common:actions.confirm")}
            cancelButtonTitle={t("common:actions.cancel")}
            onSubmit={this.salvarForragemCsv}
            onCancel={this.handleClose}
          />
        )}
      </>
    );
  }
}

ForageOptions.propTypes = {
  classes: PropTypes.object.isRequired,
  fazendaSelecionada: PropTypes.number,
};

const mapDispatchToProps = {
  notifyInfo: actions.notifyInfo,
  notifyError: actions.notifyError,
  notifySuccess: actions.notifySuccess,
};

function mapStateToProps({ fazenda }) {
  return {
    fazendaSelecionada: fazenda.FazendaSelecionada,
    toggles: fazenda.Toggles,
  };
}

const styles = {
  modal: {
    zIndex: 3000,
  },
  modalText: {
    fontSize: "16px",
    fontFamily: "Roboto",
  },
  containerInfo: {
    margin: "32px 0px 16px 0px",
  },
  subtitle: {
    fontSize: "16px",
    fontFamily: "Roboto",
    letterSpacing: "normal",
  },
  dialogConfirm: {
    color: "#333333",
  },
  divider: {
    margin: "32px 0px 16px 0px",
  },
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ForageOptions));
